import React, { useEffect, useState } from 'react'
import { Avatar, Box, Chip, CircularProgress, IconButton, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import MeetingsService from '../../services/MeetingsService'
import CurrentClientProvider from '../../providers/CurrentClientProvider'
import SectionTitle from '../../components/common/SectionTitle'

function advisorName(advisor) {
  return [advisor?.first_name, advisor?.last_name].filter(Boolean).join(' ')
}

export default function M1AdvisorsManagement() {
  const clientContext = CurrentClientProvider.useClient() || {}
  const client = clientContext.client || {}
  const clientId = client.Id ?? client.id
  const clientCode = client.ClientCode

  const [advisor, setAdvisor] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!clientId) { setAdvisor(null); setLoading(false); return undefined }
    let cancelled = false
    setLoading(true)
    MeetingsService.getAdvisor(clientId, clientCode)
      .then((result) => { if (!cancelled) setAdvisor(result || null) })
      .catch(() => { if (!cancelled) setAdvisor(null) })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [clientId, clientCode])

  // Live advisor (as resolved on the Meetings "Your Advisor" header) mapped onto the same
  // card shape as before — correct name, no notes line.
  const cardAdvisor = advisor ? {
    first_name: advisor.name || 'Your Management One advisor',
    last_name: '',
    status: 'active',
    short_description: advisor.title || '',
    avatar_url: advisor.avatarUrl,
  } : null

  return <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
    <SectionTitle title="M1 Advisors" subtitle="Manage the advisor profiles shown on the V3 client dashboard." />
    {loading ? <Box sx={{ py: 8, textAlign: 'center' }}><CircularProgress /></Box> : <Box sx={{ mt: 2, display: 'grid', gap: 1.5 }}>
      {!cardAdvisor && <Typography color="text.secondary">No advisor found for this client.</Typography>}
      {cardAdvisor && <Box sx={{ border: '1px solid #e5e7eb', borderRadius: 2, p: 2, bgcolor: '#fff', display: 'flex', gap: 2 }}>
        <Avatar src={cardAdvisor.avatar_url || undefined} sx={{ width: 56, height: 56 }}>{advisorName(cardAdvisor).slice(0, 2).toUpperCase()}</Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}><Typography fontWeight={700}>{advisorName(cardAdvisor)}</Typography><Chip size="small" label={cardAdvisor.status} color={cardAdvisor.status === 'active' ? 'success' : 'default'} /></Box>
          <Typography sx={{ mt: 0.5 }} variant="body2" color="text.secondary">{cardAdvisor.short_description}</Typography>
        </Box>
        <IconButton aria-label={`Edit ${advisorName(cardAdvisor)}`} onClick={() => {}}><EditIcon /></IconButton>
        <IconButton aria-label={`Delete ${advisorName(cardAdvisor)}`} color="error" onClick={() => {}}><DeleteIcon /></IconButton>
      </Box>}
    </Box>}
  </Box>
}
